(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manufacturers-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.manufacturers-slider');
  
  sliders.forEach(slider => {
    const pauseOnHover = slider.dataset.pauseHover === 'true';
    const track = slider.querySelector('.manufacturers-slider__inner');
    
    if (pauseOnHover) {
      track.addEventListener('mouseover', () => {
        const trackElements = track.querySelectorAll('.manufacturers-slider__track');
        trackElements.forEach(el => {
          el.style.animationPlayState = 'paused';
        });
      });
      
      track.addEventListener('mouseout', () => {
        const trackElements = track.querySelectorAll('.manufacturers-slider__track');
        trackElements.forEach(el => {
          el.style.animationPlayState = 'running';
        });
      });
    }
    
    // Patikriname, ar yra pakankamai logotipų, kad užpildytų visą juostą
    setTimeout(() => {
      const items = slider.querySelectorAll('.manufacturers-slider__track:first-child .manufacturers-slider__item');
      const trackWidth = slider.querySelector('.manufacturers-slider__track').offsetWidth;
      const containerWidth = slider.offsetWidth;
      
      // Jeigu logotipų per mažai, pakoreguojame animaciją
      if (trackWidth < containerWidth * 2 && items.length > 0) {
        const tracks = slider.querySelectorAll('.manufacturers-slider__track');
        tracks.forEach(track => {
          // Kartojame logotipus, kol užpildome visą juostą
          const itemsNeeded = Math.ceil((containerWidth * 2) / (trackWidth / items.length));
          const currentItems = track.querySelectorAll('.manufacturers-slider__item').length;
          
          if (currentItems < itemsNeeded) {
            for (let i = 0; i < Math.min(itemsNeeded - currentItems, items.length); i++) {
              const clone = items[i % items.length].cloneNode(true);
              track.appendChild(clone);
            }
          }
        });
      }
    }, 500);
  });
});

  } catch(e) { console.error(e); }
})();
})();
